window.onload = () => {
  document.getElementsByClassName('tox-tinymce')[0].style.border = 'none';
  document.getElementsByClassName('tox-tinymce')[1].style.border = 'none';
  document.getElementsByClassName('tox-edit-area__iframe')[0].style.background = '#00000000';
  document.getElementsByClassName('tox-edit-area__iframe')[1].style.background = '#00000000';
  document.getElementsByClassName('tox-statusbar')[0].style.borderTop = 'none';
  document.getElementsByClassName('tox-statusbar')[1].style.borderTop = 'none';
  document.getElementsByClassName('tox-statusbar')[0].style.background = '#00000000';
  document.getElementsByClassName('tox-statusbar')[1].style.background = '#00000000';
  document.getElementsByTagName('form')[0].attributes.removeNamedItem('action');
  document.getElementsByTagName('form')[0].attributes.removeNamedItem('method');
  document.getElementsByTagName('form')[1].attributes.removeNamedItem('action');
  document.getElementsByTagName('form')[1].attributes.removeNamedItem('method');
};
